// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"ab82233d","942":"971fddd7"}[chunkId] + ".chunk.css";
};